import { createFileRoute } from '@tanstack/react-router'
import { PricingPage } from '../components/pricing-page'
import { staticRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/preise')({
  head: () => staticRouteHead('pricing', 'de'),
  component: PricingPage,
})
